import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LinkTreeApp from './components/LinkTreeApp';
import JsonBuilder from './components/JsonBuilder';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/builder" element={<JsonBuilder />} />
        <Route path="/" element={<LinkTreeApp />} />
      </Routes>
    </Router>
  );
}

export default App;